"use client"
import React from "react";
import Marquee from "react-marquee-text";

export type CrawlerProps = {
  children?: string | null;
  duration?: number;
  className?: string;
};

const Crawler: React.FC<CrawlerProps> = ({ children, duration = 5, className = "" }) => {
  const text = typeof children === "string" ? children : String(children ?? "");

  if (!text) return null;

  // simple cost-free check; no need to useMemo here
  const needsCrawl = text.length >= 25;

  if (!needsCrawl) return <div className={className}>{text}</div>;

  return (
    <Marquee
      pauseOnHover
      playOnlyInView={false}
      textSpacing="5em"
      duration={duration}
      direction="right"
      className={className}
    >
      {text}
    </Marquee>
  );
};

export default Crawler;
